/**
 * The WalletConnect pairing URI, passed from the adapter to our own QR step.
 *
 * `WalletConnectAdapter.connect({ onUri })` skips AppKit's modal when a callback is
 * given, which is what lets the pairing be rendered in our dialog instead of a second,
 * differently-styled one on top of it.
 */
let sink = null;
export function setWalletConnectUriSink(next) {
    sink = next;
}
export function emitWalletConnectUri(uri) {
    sink?.(uri);
}
//# sourceMappingURL=connect-uri.js.map